import { createContext } from "react";
const LocaleContext = createContext({
    locale: 'zh-CN'
});
export default LocaleContext;
